<template>
  <div class="modal fade" :id="'createVariationModal' + id" data-backdrop="static" tabindex="-1" role="dialog"
       aria-labelledby="staticBackdrop" aria-hidden="true">
    <div class="modal-dialog" role="document">
      <form @submit.prevent="createAttributData" class="form">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ $t('button.add') }}</h5>

            <!--begin::Close-->
            <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" @click="closeModal">
              <!--begin::Svg Icon | path: icons/duotune/arrows/arr061.svg-->
              <span class="svg-icon svg-icon-1">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)"
                        fill="currentColor"/>
                  <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)"
                        fill="currentColor"/>
                </svg>
              </span>
              <!--end::Svg Icon-->
            </div>
            <!--end::Close-->
          </div>
          <div class="modal-body">
            <div class="d-flex flex-column mb-8 fv-row">
              <!--begin::Label-->
              <label class="d-flex align-items-center fs-6 fw-bold mb-2">
                <span class="required">{{ $t('attribut.name') }}</span>
              </label>
              <!--end::Label-->
              <input type="text" class="form-control form-control-solid" v-model="formCreateData.name" required/>
            </div>

            <div class="form-group row">
              <div class="col-md-12">
                <label class="d-flex align-items-center fs-6 fw-bold mb-2" for="">{{ $t('attribut.value') }}<span class="text-danger">*</span> </label>
                <input id="kt_tagify_value_" class="form-control tagify " type="text" required/>
                <small id="valueHelpBlock" class="form-text text-muted"> {{ $t('attribut.tag_input_text') }} </small>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-sm btn-light" data-bs-dismiss="modal">{{ $t('button.close') }}</button>
            <button type="submit" id="kt_submit_add_attribut" class="btn btn-sm btn-primary fw-bolder">
              <span class="indicator-label">{{ $t('button.save') }}</span>
              <span class="indicator-progress">{{ $t('loading') }}
                <span class="spinner-border spinner-border-sm align-middle ms-2"></span></span>
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import {mapActions} from "vuex";

export default {
  props: {
    id: {
      required: false,
      type: String,
      default: '1'
    },
    source: {
      required: false,
      type: String
    },
    hasParent: {
      required: false,
      type: Boolean
    }
  },

  data() {
    return {
      formCreateData: {
        name: '',
        variation: [],
      },
    }
  },

  mounted() {
    this.tagifyValue()
  },

  methods: {
    ...mapActions('attributs', [
      'createAttribut',
    ]),

    closeModal(){
      $('#createVariationModal' + this.id).modal('toggle')
      if(this.hasParent){
          $('#' + this.source).modal('toggle')
      }
    },

    async createAttributData() {
      this.$loading('kt_submit_add_attribut')

      try {
        let response = await this.createAttribut(this.formCreateData)
        this.formCreateData = {
          name: '',
          value: '',
        }
        window.toastr['success'](i18n.global.t("notification.attribut_created"))
        this.$emit('variationCreated', response.data.variation)

        $('#createVariationModal' + this.id).modal('toggle')
        if(this.hasParent){
          $('#' + this.source).modal('toggle')
        }
        document.getElementById("kt_tagify_value_").value = "";
        this.$stopLoading('kt_submit_add_attribut')
      }catch(err){
        this.$stopLoading('kt_submit_add_attribut')
      }
    },

    tagifyValue() {
      var eValue
      eValue = document.getElementById("kt_tagify_value_")

      this.variation = new Tagify(eValue)

      this.variation.on("invalid", function (e) {
        if (e.detail.data.__isValid === 'pattern mismatch') {
          window.toastr['error']('variation invalid')
        }
      })
          .on('add', () => {
            this.formCreateData.variation = this.variation.value.map(x => x.value)
          })
          .on("remove", () => {
            this.formCreateData.variation = this.variation.value.map(x => x.value)
          })
    },
  }
}
</script>